// extracted by mini-css-extract-plugin
var _1 = "SettingsModal__alignLeft___u4hrn";
var _2 = "SettingsModal__check___yTJQa";
var _3 = "SettingsModal__optionsContainer___tWl9a";
var _4 = "SettingsModal__setttingsContainer___FfiPq";
var _5 = "SettingsModal__wiggle___mTv7s";
export { _1 as "alignLeft", _2 as "check", _3 as "optionsContainer", _4 as "setttingsContainer", _5 as "wiggle" }
